module.exports = __webpack_public_path__ + "img/Attack_triple dragon.e01f50ee.png";